import React from "react";
import {Form, Input, Tooltip} from "antd";

export default class TokenBucketRateLimiter extends React.Component<any, any> {
    render() {
        return (
            <>
                <Tooltip title={"这是路由每秒所能允许的最大请求数量"}>
                    <Form.Item label={"每秒最大请求"} name={"maxReqPerSec"} wrapperCol={{span: 7}}>
                        <Input type={"number"} min={0} placeholder={"每秒最大请求"}/>
                    </Form.Item>
                </Tooltip>
                <Tooltip title={"这是路由每秒所能处理且不丢弃的请求数量"}>
                    <Form.Item label={"平均请求速率"} name={"avgReqPerSec"} wrapperCol={{span: 7}}>
                        <Input type={"number"} min={0}/>
                    </Form.Item>
                </Tooltip>
            </>
        );
    }
}
